/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import { TransferType } from '@bb/users';

import { Icon, Popconfirm } from 'components';

import FormContext from '../../FormContext';
import { AlertRightItems, LinkButton, StyledAlert } from '../../components';

interface OutgoingPendingTransferAlertProps {
  acceptTransfer: () => Promise<void>;
  denyTransfer: () => Promise<void>;
}
const OutgoingPendingTransferAlert = ({
  acceptTransfer,
  denyTransfer,
}: OutgoingPendingTransferAlertProps) => {
  const { transfer, working, isProfile, branchValid, addressValid } =
    useContext(FormContext);

  if (transfer?.type !== TransferType.Outgoing) return null;

  let message: JSX.Element;
  let actionItems: JSX.Element;

  if (isProfile) {
    message = (
      <>
        <strong>{transfer?.otherOrgDetails.name}</strong> is requesting to
        transfer you to their brokerage
      </>
    );
    actionItems = (
      <>
        <Popconfirm
          title="Are you sure? Accepting this invitation will archive your existing listing data, showing settings, and contacts. You’ll be logged out of this session and you’ll have to log back in to your new brokerage."
          okText="Yes, Continue"
          cancelText="No"
          onConfirm={acceptTransfer}
          width={336}
          disabled={!branchValid || !addressValid || working}
          placement="bottomRight"
        >
          <LinkButton disabled={!branchValid || !addressValid || working}>
            Accept
          </LinkButton>
        </Popconfirm>
        <LinkButton onClick={denyTransfer} disabled={working}>
          Deny
        </LinkButton>
      </>
    );
  } else {
    message = (
      <>
        <strong>{transfer?.otherOrgDetails.name}</strong> has requested that{' '}
        <strong>
          {transfer?.user.firstName} {transfer?.user.lastName}
        </strong>{' '}
        be transferred to their brokerage
      </>
    );
    actionItems = (
      <>
        <LinkButton onClick={acceptTransfer} disabled={working}>
          Accept
        </LinkButton>
        <LinkButton onClick={denyTransfer} disabled={working}>
          Deny
        </LinkButton>
      </>
    );
  }

  return (
    <StyledAlert
      message={<span>{message}</span>}
      action={<AlertRightItems>{actionItems}</AlertRightItems>}
      type="warning"
      showIcon
      icon={<Icon type="antdSwapOutlined" color="alertWarningIconColor" />}
    />
  );
};

export default OutgoingPendingTransferAlert;
